import React, { useState } from "react";
import ButtonComponent from "../elements/ButtonComponent";
import { RenderDownloadProps, getFilePlugin } from "@react-pdf-viewer/get-file";
import { RenderPrintProps, printPlugin } from "@react-pdf-viewer/print";
import PdfViewer from "../elements/PdfViewerComponent";
import { motion } from "framer-motion";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";
import { childVariants } from "../../animation/RoutesAnimations";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import { axiosPrivate } from "../../api/axios";
import { STORE_ACCEPT_CONTRACT } from "../../api/apiClient";

interface SellerFormStep7Types {
  // onBack?: any;
  control: any;
  setFormNo: any;
  formNo: any;
  // errors?: any;
  setIsLoadingContents?: any;
}

const SellerFormStep7: React.FC<SellerFormStep7Types> = ({
  // onBack,
  // errors,
  setFormNo,
  formNo,
}) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);

  const getPrintPluginInstance = printPlugin();
  const { Print } = getPrintPluginInstance;
  const access_token = localStorage.getItem("access_token");
  const [isSubmiting, setIsSubmiting] = useState(false);
  const store_uid = localStorage.getItem("selected_store_uid");
  const getFilePluginInstance = getFilePlugin();
  const { Download } = getFilePluginInstance;

  // const defaultLayoutPluginInstance = defaultLayoutPlugin({
  //   sidebarTabs: (defaultTabs) => [defaultTabs[0]],
  //   renderToolbar: (Toolbar: (props: ToolbarProps) => ReactElement) => (
  //     <Toolbar />
  //   ),
  // });

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  async function handelSubmit() {
    setIsSubmiting(true);
    const formattedData = { store_uid };
    try {
      const response = await axiosPrivate.post(
        STORE_ACCEPT_CONTRACT,
        formattedData,
        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      setFormNo(formNo + 1);

      if (response?.status >= 200 && response?.status < 300) {
        setIsSubmiting(false);
      } else {
        console.error(
          "ERROR in acceptRules:",
          response.data || response.statusText
        );
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      setIsSubmiting(false);
    }
  }

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          className="flex flex-1 gap-12  rounded-md shadow-md  "
        >
          <div className=" w-full h-144 rounded-lg">
            <PdfViewer
              PdfViewerDownloadPlugin={getFilePluginInstance}
              PdfViewerPrintPlugin={getPrintPluginInstance}
              thumbnails
              fileUrl={"https://arxiv.org/pdf/1701.04279.pdf"}
            ></PdfViewer>
            <div className="flex lg:flex-row sm:flex-col max-sm:flex-col w-full content-start items-center mt-4 justify-start lg:gap-8 sm:gap-4 max-sm:gap-4">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="consentCheckbox"
                  className="h-5 w-5"
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="consentCheckbox" className="text-gray-900">
                  اطلاعات قرارداد را تایید کرده و آن را میپذیرم.
                </label>
              </div>
              <div className="flex w-[210px] justify-between items-center">
                <Download>
                  {(props: RenderDownloadProps) => (
                    <button
                      type="button"
                      onClick={props.onClick}
                      className="flex pt-2.5 pb-2.5 p-4 gap-2 items-center rounded-lg w-[100px] h-10 border border-solid border-gray-600 hover:bg-gray-200 focus:bg-gray-200"
                    >
                      <img
                        className="flex"
                        src="/icons/download-outline.svg"
                        alt="download"
                      />
                      <h1 className="text-gray-900 text-center Body-OneLine/14/Medium">
                        دانلود
                      </h1>
                    </button>
                  )}
                </Download>
                <Print>
                  {(props: RenderPrintProps) => (
                    <button
                      type="button"
                      onClick={props.onClick}
                      className="flex pt-2.5 pb-2.5 p-4 gap-2 items-center rounded-lg w-[100px] h-10 border border-solid border-gray-600 hover:bg-gray-200 focus:bg-gray-200"
                    >
                      <img
                        className="flex"
                        src="/icons/printer-outline.svg"
                        alt="print"
                      />
                      <h1 className="text-gray-900 text-center Body-OneLine/14/Medium">
                        چاپ
                      </h1>
                    </button>
                  )}
                </Print>
              </div>
            </div>

            <div className="flex justify-center md:justify-end gap-1 pb-4">
              <ButtonComponent
                type="button"
                className="mt-8 w-[120px] h-10 "
                variant="outlined"
                // onClick={onBack}
              >
                بازگشت
              </ButtonComponent>
              <ButtonComponent
                isClicked={isSubmiting}
                type="button"
                disabled={!isCheckboxChecked}
                className="mt-8 w-[120px] h-10"
                variant="filled"
                onClick={() => handelSubmit()}
                title={
                  !isCheckboxChecked
                    ? "لطفاً گزینه رضابت به اعتبارسنجی وامسی را انتخاب نمایید."
                    : ""
                }
              >
                ادامه
              </ButtonComponent>
            </div>
          </div>
        </motion.form>
      )}
    </>
  );
};

export default SellerFormStep7;
